var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStakeInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Circle - 1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Info-Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M18.3337 9.99935C18.3337 14.6027 14.6028 18.3327 10.0003 18.3327C5.39783 18.3327 1.66699 14.6027 1.66699 9.99935C1.66699 5.39768 5.39783 1.66602 10.0003 1.66602C14.6028 1.66602 18.3337 5.39768 18.3337 9.99935Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M9.99577 12.4396C10.4066 12.4396 10.7333 12.7671 10.7333 13.1688C10.7333 13.5705 10.4066 13.898 10.0041 13.898C9.59994 13.898 9.27077 13.5705 9.27077 13.1688C9.27077 12.7671 9.5966 12.4396 9.99577 12.4396ZM9.99577 6.1123C10.3974 6.1123 10.7249 6.4398 10.7249 6.84147V10.5248C10.7249 10.9265 10.3974 11.254 9.99577 11.254C9.5941 11.254 9.2666 10.9265 9.2666 10.5248V6.84147C9.2666 6.4398 9.5941 6.1123 9.99577 6.1123Z",
    fill: "#E5B910"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeInfoCircle);
export default __webpack_public_path__ + "static/media/stake-info-circle.cb233e3db4532a7484d5c89ee3929e71.svg";
export { ForwardRef as ReactComponent };